// @core/api/endpoints/search/create_search_index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSearchIndexRequest,
  SearchIndexResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Create search index
 * Creates a new search index configuration for a product. Defines which entity types to index and how fields are weighted.
 */
export async function CreateSearchIndex(
  data: CreateSearchIndexRequest,
  options?: RequestOptions
): Promise<SearchIndexResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/indexes`;
  const requestOptions = options;
  return client.post<SearchIndexResponse>(requestPath, data, requestOptions);
}
